import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'

import ConfirmDialog from 'components/ConfirmDialog'

import FormPS from './form-ps'
import { savePaymentScheme, deletePaymentScheme } from './actions'

class FormContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openConfirm: false,
    }
  }

  _openConfirm = () => {
    this.setState({
      openConfirm: true,
    })
  }

  _onSubmit = (input) => {
    this.props.dispatch(savePaymentScheme(input))
    .then((res) => {
      if (!res.error) {
        this.props.close()
        this.context.router.push(`/manage/payment-schemes/${res.payload.id}`)
      }
    })
  }

  _onConfirmDelete = () => {
    const { dispatch, item, close } = this.props
    dispatch(deletePaymentScheme(item.get('id')))
    .then((res) => {
      if (!res.error) {
        close()
        this.context.router.replace('/manage/payment-schemes')
      }
    })
  }

  _renderConfirmDialog() {
    const { openConfirm } = this.state

    if (!openConfirm) {
      return null
    }

    return (
      <ConfirmDialog
        closeDialog={() => this.setState({ openConfirm: false })}
        confirmAction={this._onConfirmDelete}
      />
    )
  }

  render() {
    const {
      item,
      __pending,
    } = this.props

    return (
      <div>
        <FormPS
          item={item}
          pending={__pending}
          onSubmit={this._onSubmit}
          onDelete={this._openConfirm}
        />
        {this._renderConfirmDialog()}
      </div>
    )
  }
}

FormContainer.contextTypes = {
  router: PropTypes.object,
}

FormContainer.propTypes = {
  __pending: PropTypes.bool,
  item: PropTypes.object,
  close: PropTypes.func,
  dispatch: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __pending: state.paymentscheme.get('pending'),
  }
}

export default connect(mapStateToProps)(FormContainer)



// WEBPACK FOOTER //
// ./src/containers/Manage/PaymentSchemes/form-container.js